module.exports = __webpack_public_path__ + "h5/img/collect_btn.70a86555.png";